import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PrivateRoute = ({ children, requiredRole }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // Redirect to appropriate dashboard based on role
  const roleRoutes = {
    superadmin: '/superadmin',
    client: '/client',
    manager: '/manager',
    employee: '/employee'
  };

  const currentPath = location.pathname;
  const userRoute = roleRoutes[user.role];

  // If user is on wrong route, redirect to their role's route
  if (currentPath !== userRoute) {
    return <Navigate to={userRoute} replace />;
  }

  return children;
};

export default PrivateRoute;

